<div class="mfa-setup-container">
  <div class="setup-card">
    <div class="card-header">
      <h2>多因素認證 (MFA) 設定</h2>
    </div>

    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="loading" class="loading-state">
        <div class="spinner"></div>
        <p>處理中，請稍候...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="error" class="error-message">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{ error }}</span>
        <button class="btn-retry" (click)="onRestart()">重試</button>
      </div>

      <!-- Step 1: Initialization -->
      <div *ngIf="isInitStep && !loading && !error" class="step-content">
        <div class="step-header">
          <i class="fas fa-shield-alt"></i>
          <h3>正在初始化 MFA 設定...</h3>
        </div>
        <p>請稍候，系統正在為您準備多因素認證設定。</p>
      </div>

      <!-- Step 2: QR Code Display -->
      <div *ngIf="isVerifyStep && !loading && !error" class="step-content">
        <div class="step-header">
          <i class="fas fa-qrcode"></i>
          <h3>步驟 1: 掃描 QR Code</h3>
        </div>

        <div class="qr-code-section">
          <div class="qr-code-container">
            <img [src]="setupState.qrCodeImage"
                 alt="MFA QR Code"
                 class="qr-code-image">
          </div>

          <div class="qr-code-info">
            <h4>使用驗證器應用程式掃描此 QR Code</h4>
            <p>請使用 Google Authenticator、Microsoft Authenticator 或其他 TOTP 驗證器應用程式掃描上方的 QR Code。</p>
<!--
            <div class="account-info">
              <p><strong>發行者:</strong> {{ setupState.issuer }}</p>
              <p><strong>帳戶:</strong> {{ setupState.accountName }}</p>
            </div> -->
          </div>
        </div>

        <div class="verification-section">
          <h4>步驟 2: 輸入驗證碼</h4>
          <p>掃描完成後，請輸入您的驗證器應用程式顯示的 6 位數驗證碼：</p>

          <form [formGroup]="verificationForm" (ngSubmit)="onVerify()">
            <div class="form-group">
              <input type="text"
                     class="form-control verification-input"
                     formControlName="verificationCode"
                     placeholder="請輸入 6 位數驗證碼"
                     maxlength="6"
                     autocomplete="off">

              <div *ngIf="verificationForm.get('verificationCode')?.invalid && verificationForm.get('verificationCode')?.touched"
                   class="error-text">
                請輸入有效的 6 位數驗證碼
              </div>
            </div>

            <div class="button-group">
              <button type="submit"
                      class="btn btn-primary"
                      [disabled]="verificationForm.invalid || loading">
                <i class="fas fa-check"></i>
                驗證並完成設定
              </button>

              <button type="button"
                      class="btn btn-secondary"
                      (click)="onRestart()">
                <i class="fas fa-redo"></i>
                重新開始
              </button>

              <button type="button"
                      class="btn btn-outline-secondary"
                      (click)="onCancel()">
                <i class="fas fa-times"></i>
                取消設定
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Step 3: Setup Complete -->
      <div *ngIf="isCompleteStep && !loading && !error" class="step-content">
        <div class="step-header success">
          <i class="fas fa-check-circle"></i>
          <h3>MFA 設定完成！</h3>
        </div>

        <div class="success-content">
          <p>恭喜！您已成功啟用多因素認證。</p>

          <div class="backup-codes-section">
            <h4>重要：備用碼</h4>
            <p>請妥善保存以下備用碼，當您無法存取驗證器應用程式時可以使用：</p>

            <div class="backup-codes">
              <div *ngFor="let code of setupState.backupCodes" class="backup-code">
                {{ code }}
              </div>
            </div>

            <div class="backup-codes-warning">
              <i class="fas fa-exclamation-triangle"></i>
              <span>請將這些備用碼儲存在安全的地方。每個備用碼只能使用一次。</span>
            </div>
          </div>

          <div class="button-group">
            <button class="btn btn-primary" (click)="onComplete()">
              <i class="fas fa-home"></i>
              返回主頁
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
